// ServiceCard.js
import React from 'react';

const ServiceCard = ({ icon, title, services, delay }) => {
  return (
    <div className="col-xl-3 col-lg-4 col-sm-6 col-12 mb-24 rx-575-50" data-aos="flip-left" data-aos-duration="1000" data-aos-delay={delay}>
      <div className="rx-services">
        <div className="services-ico">
           <i className={icon}></i>
          {/* <img src={icon} alt={title} className="svg-img" /> */}
        </div>
        <div className="services-contact">
          <h5>{title}</h5>
          <ul>
            {services.map((service, index) => (
              <li key={index}>- {service}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
